import Text from "components/Text";
import { Link } from "react-router-dom";
import styled from "styled-components";
import theme from "theme";

export const LinkStyled = styled(Link)<{
    to: string;
    color?: string;
    hoverColor?: string;
    activeColor?: string;
    underline?: boolean;
}>`
    ${Text.Style} {
        color: ${({ color }) => color || theme.link.color};
        text-decoration: ${({ underline }) =>
            underline ? "underline" : "none"};
    }
    &:active {
        ${Text.Style} {
            color: ${({ activeColor }) =>
                activeColor || theme.link.activeColor};
        }
    }
    &:hover {
        ${Text.Style} {
            color: ${({ hoverColor }) => hoverColor || theme.link.hoverColor};
            text-decoration: underline;
            outline-width: 0;
            cursor: pointer;
        }
    }
`;
